import {
  IntlProvider as FusionIntlProvider,
  ThemeProvider as FusionThemeProvider
} from '@ps/web-fusion-components';
import { IntlProvider, ScreenSizeProvider } from '@ps/web-shared-components';
import { setAutoFreeze } from 'immer';
import React from 'react';
import type { ResolvedIntlConfig } from 'react-intl';
import { Provider as ReduxProvider } from 'react-redux';

import ThemeProvider from '@swf/core/providers/ThemeProvider';
import TimerProvider from '@swf/core/providers/TimerProvider';
import type { Store } from '@swf/core/store';

import '@swf/core/styles/main.scss';

// https://immerjs.github.io/immer/docs/freezing
setAutoFreeze(false);

interface ProvidersProps extends React.PropsWithChildren {
  store: Store;
  messages?: ResolvedIntlConfig['messages'];
}

const Providers: React.FC<ProvidersProps> = ({ store, messages, children }) => (
  <ReduxProvider store={store}>
    <FusionThemeProvider theme="ps-light">
      <ThemeProvider>
        <ScreenSizeProvider>
          <TimerProvider>
            <FusionIntlProvider locale={store.getState().locale}>
              <IntlProvider messages={messages}>{children}</IntlProvider>
            </FusionIntlProvider>
          </TimerProvider>
        </ScreenSizeProvider>
      </ThemeProvider>
    </FusionThemeProvider>
  </ReduxProvider>
);

export default Providers;
